export default [
    {
        path: 'tasks',
        name: 'master-data-tasks',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.tasks').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        children: [
            {
                path: 'types',
                name: 'tasks-task-types',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.task_types').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'tasks-task-types-list' },
                children: [
                    {
                        path: '',
                        name: 'tasks-task-types-list',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t) => {
                                return t('menu_points.task_types').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/tasks/types/list.vue')
                    },
                    {
                        path: 'create',
                        name: 'tasks-task-type-create',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.create_new_item', {item: tc('tasks::types.type', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/tasks/types/item.vue'),
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'tasks-task-type-edit',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.edit_item', {item: tc('tasks::types.type', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/tasks/types/item.vue'),
                    },
                ]
            },
            {
                path: 'priorities',
                name: 'tasks-task-priorities',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.tasks_master_data.priorities').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'tasks-task-priorities-list' },
                children: [
                    {
                        path: '',
                        name: 'tasks-task-priorities-list',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t) => {
                                return t('menu_points.tasks_master_data.priorities').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/tasks/priorities/list.vue')
                    },
                    {
                        path: 'create',
                        name: 'tasks-task-priority-create',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.create_new_item', {item: tc('tasks::priorities.priority', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/tasks/priorities/item.vue'),
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'tasks-task-priority-edit',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.edit_item', {item: tc('tasks::priorities.priority', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/tasks/priorities/item.vue'),
                    },
                ]
            },
            {
                path: 'statuses',
                name: 'tasks-task-statuses',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.tasks_master_data.statuses').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'tasks-task-statuses-list' },
                children: [
                    {
                        path: '',
                        name: 'tasks-task-statuses-list',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t) => {
                                return t('menu_points.tasks_master_data.statuses').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/tasks/statuses/list.vue')
                    },
                    {
                        path: 'create',
                        name: 'tasks-task-status-create',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.create_new_item', {item: tc('tasks::statuses.status', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/tasks/statuses/item.vue'),
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'tasks-task-status-edit',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.edit_item', {item: tc('tasks::statuses.status', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/tasks/statuses/item.vue'),
                    },
                ]
            },
            {
                path: 'templates',
                name: 'tasks-task-templates',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.tasks_master_data.templates').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'tasks-task-templates-list' },
                children: [
                    {
                        path: '',
                        name: 'tasks-task-templates-list',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t) => {
                                return t('menu_points.tasks_master_data.templates').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/tasks/templates/list.vue')
                    },
                    {
                        path: 'create',
                        name: 'tasks-task-template-create',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.create_new_item', {item: tc('tasks::templates.template', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/tasks/templates/item.vue'),
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'tasks-task-template-edit',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.edit_item', {item: tc('tasks::templates.template', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/tasks/templates/item.vue'),
                    },
                ]
            },
            {
                path: 'tasks',
                name: 'tasks-tasks',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.tasks').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'tasks-tasks-list' },
                children: [
                    {
                        path: '',
                        name: 'tasks-tasks-list',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t) => {
                                return t('menu_points.tasks_master_data.tasks').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/tasks/tasks/list.vue')
                    },
                    {
                        path: 'create',
                        name: 'tasks-task-create',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.create_new_item', {item: tc('tasks::tasks.task', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/tasks/tasks/item.vue'),
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'tasks-task-edit',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.edit_item', {item: tc('tasks::tasks.task', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/tasks/tasks/item.vue'),
                    },
                ]
            },
        ]
    }
];